"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObj = isObj;
exports.hasProp = hasProp;
/**
 * GENERATED CODE - DO NOT MODIFY
 */
function isObj(v) {
    return typeof v === 'object' && v !== null;
}
function hasProp(data, prop) {
    return prop in data;
}
//# sourceMappingURL=util.js.map